import React from 'react';
import {View} from 'react-native';
import CCColors from '@/Utils/CCColors';
import customStyles from '../styles';

export const CardResultStrip = ({result}: {result: string}) => {
  const resultLower = result?.toLowerCase() ?? 'draw';

  const colorMap: Record<string, [string, string]> = {
    win: [CCColors.GameReview.Green, CCColors.GameReview.GreenDark],
    loss: [CCColors.GameReview.Red, CCColors.GameReview.RedDark],
    draw: [CCColors.GameReview.GoldDark, CCColors.GameReview.GoldDarker],
  };

  const colors = colorMap[resultLower] ?? colorMap.draw;
  const rows = 7;
  const cells = Array.from({length: rows * 2});

  return (
    <View style={customStyles.resultStrip}>
      {cells.map((_, i) => {
        const row = Math.floor(i / 2);
        const col = i % 2;
        const isDark = (row + col) % 2 === 0;
        return (
          <View
            key={i}
            style={{
              width: '50%',
              height: `${100 / rows}%`,
              backgroundColor: isDark ? colors[1] : colors[0],
            }}
          />
        );
      })}
    </View>
  );
};

export default CardResultStrip;
